import { doc, getDoc } from 'firebase/firestore';
import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { UserContext } from '../contexts/UserContext';
import { db } from '../firebase';

const PreviousTranscation = () => {
  const [trades, setTrades] = useState([]);
  const userCtx = useContext(UserContext);

  useEffect(() => {
    const getData = async () => {
      const docRef = doc(db, 'users', userCtx.userId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        if (docSnap.data().trades) {
          setTrades(docSnap.data().trades);
        }
      }
    };

    getData();
  }, []);

  console.log(trades);

  return (
    <div className="p-10">
      {' '}
      <>
        <div className="overflow-x-auto flex flex-col gap-5">
          <h2 className="text-2xl font-semibold">Transaction</h2>
          {trades && trades.length === 0 ? (
            <div>There is no transaction</div>
          ) : (
            <table className="w-full border-collapse min-w-[800px]">
              <thead>
                <tr>
                  <th className="border border-gray-400 px-4 py-2">Coin</th>
                  <th className="border border-gray-400 px-4 py-2">Buy/Sell</th>
                  <th className="border border-gray-400 px-4 py-2">
                    Target Price
                  </th>
                  <th className="border border-gray-400 px-4 py-2">
                    Stop Price
                  </th>
                  <th className="border border-gray-400 px-4 py-2">
                    Open price
                  </th>
                  <th className="border border-gray-400 px-4 py-2">
                    Start Time
                  </th>
                  <th className="border border-gray-400 px-4 py-2">State</th>
                </tr>
              </thead>
              <tbody>
                {trades.map((trade) => (
                  <tr key={trade.id}>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade?.currentSymbol || ''}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade.flipFlop ? 'Buy' : 'Sell'}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade.targetPrice}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade.stopLossPrice}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade.openPrice}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {trade.startTime}
                    </td>
                    <td
                      className={`border border-gray-400 px-4 py-2 font-semibold ${
                        trade.state === 'profit'
                          ? 'text-green-500'
                          : 'text-red-500'
                      }`}
                    >
                      {trade.state}
                    </td>
                  </tr>
                ))}

                <div className="mt-5 font-medium">
                  Total Profit:{' '}
                  {trades.filter((trade) => trade.state === 'profit').length}
                </div>

                <div className="font-medium">
                  Total Loss:{' '}
                  {trades.filter((trade) => trade.state === 'loss').length}
                </div>

                {/*    <tr className="text-center font-medium">
                <td
                  className={`border border-gray-400 px-4 py-2 ${
                    flipFlop ? 'text-green-600' : 'text-red-500'
                  }`}
                >
                  {flipFlop?.toString()}
                </td>
                <td
                  className={`border border-gray-400 px-4 py-2 ${
                    flipFlop ? 'text-green-600' : 'text-red-500'
                  }`}
                >
                  {targetPrice}
                </td>
                <td
                  className={`border border-gray-400 px-4 py-2 ${
                    flipFlop ? 'text-green-600' : 'text-red-500'
                  }`}
                >
                  {stopLossPrice}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {openPrice}
                </td>
                <td className="border border-gray-400 px-4 py-2">
                  {startTime}
                </td>
                <td className="border border-gray-400 px-4 py-2">{state}</td>
              </tr> */}
              </tbody>
            </table>
          )}
        </div>
      </>
    </div>
  );
};

export default PreviousTranscation;
